export const isValidDate = value => {
  if (Object.prototype.toString.call(value) === '[object Date]') {
    // it is a date
    if (Number.isNaN(value.getTime())) {
      // d.valueOf() could also work
      // date is not valid
      return false;
    }
    // date is valid
    return true;
  }
  // not a date
  if (!value) return false;
  return isValidDate(new Date(value));
};
